export const cardStyles = [
  {
    bg: "bg-gradient-to-br from-[#F8F9FF] to-[#E8F1FF] dark:from-gray-800/50 dark:to-gray-800/30",
    shadow: "hover:shadow-[0_0_15px_rgba(147,197,253,0.2)]",
    border: "border-[#93C5FD]/20"
  },
  {
    bg: "bg-gradient-to-br from-[#F9FAFB] to-[#F3F4F6] dark:from-gray-800/50 dark:to-gray-800/30",
    shadow: "hover:shadow-[0_0_15px_rgba(156,163,175,0.2)]",
    border: "border-[#9CA3AF]/20"
  },
  {
    bg: "bg-gradient-to-br from-[#F8F5FF] to-[#F1F0FB] dark:from-gray-800/50 dark:to-gray-800/30",
    shadow: "hover:shadow-[0_0_15px_rgba(167,139,250,0.2)]",
    border: "border-[#A78BFA]/10"
  }
];

export const getStyleForId = (id: string) => {
  const styleIndex = id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % cardStyles.length;
  return cardStyles[styleIndex];
};